<script>
export default {
  name: 'Paginate',
  props: {
    currentPage: {
      type: Number,
      required: false,
      default: 1,
    },
    totalPages: {
      type: Number,
      require: false,
      default: 3,
    },
    currentSection: {
      type: Number,
      required: false,
      default: 0,
    },
    totalRecords: {
      type: Number,
      required: false,
      default: 0,
    },
    loadPage: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      currentSection_: 0,
    }
  },
  computed: {
    section() {
      return this.currentSection_ ? this.currentSection_ : this.currentSection
    },
    totalSection() {
      if (this.totalPages % 10 !== 0)
        return Math.floor(this.totalPages / 10) + 1
      return Math.floor(this.totalPages / 10)
    },
    offset() {
      return this.section * 10
    },
    sectionPage() {
      if (
        this.totalPages % 10 &&
        this.totalSection === this.section + 1 &&
        this.totalSection > 1
      )
        return this.totalPages % 10
      return this.totalPages < 10 ? this.totalPages : 10
    },
    showingItem() {
      let showingStart = 1
      let showingEnd = 15
      if (this.currentPage === 1) {
        showingStart = 1
        showingEnd = 15
      } else {
        showingStart = 15 * (this.currentPage - 1) + 1
        showingEnd = 15 * (this.currentPage - 1) + 15

        if (showingEnd >= this.totalRecords) {
          showingEnd = this.totalRecords
        }
        if (showingEnd - showingStart === 0) {
          return `${showingStart}`
        }
      }
      return `${showingStart}-${showingEnd}`
    },
  },
  methods: {
    nextSection() {
      if (this.currentSection_ < this.totalSection) {
        this.currentSection_ += 1
      }
      this.loadPage(this.currentSection_ * 10 + 1)
    },
    previousSection() {
      if (this.currentSection_ > 0) {
        this.currentSection_ -= 1
      }
      this.loadPage(this.currentSection_ * 10 + 1)
    },
    lastSection() {
      if (this.currentSection_ < this.totalSection) {
        this.currentSection_ = this.totalSection - 1
      }
    },
    firstSection() {
      this.currentSection_ = 0
    },
  },
}
</script>
<template>
  <div class="paginate btn-group">
    <button
      v-b-tooltip.hover.top
      title="The first page"
      class="btn btn-light"
      @click.stop=";[loadPage(1), firstSection()]"
    >
      <i class="uil uil-angle-double-left"></i> First
    </button>
    <button
      v-if="totalSection > 1"
      v-b-tooltip.hover.top
      title="Previous 10 pages"
      class="btn btn-light"
      :disabled="currentSection_ === 0"
      @click.stop="previousSection"
      ><i class="uil uil-angle-left"></i> Previous</button
    >
    <button
      v-for="page in sectionPage"
      :key="page"
      class="btn btn-light"
      :class="{ active: currentPage === page + offset }"
      @click.stop="loadPage(page + offset)"
      >{{ page + offset }}</button
    >
    <button
      v-if="totalSection > 1"
      v-b-tooltip.hover.top
      title="Next 10 pages"
      class="btn btn-light"
      :disabled="totalSection === section + 1"
      @click.stop="nextSection"
      >Next <i class="uil uil-angle-right"></i
    ></button>
    <button
      v-b-tooltip.hover.top
      title="The last page"
      class="btn btn-light"
      @click.stop=";[loadPage(-1), lastSection()]"
    >
      Last <i class="uil uil-angle-double-right"></i>
    </button>
    <button class="btn btn-light" disabled>
      Showing {{ showingItem }} of {{ totalRecords }} items
    </button>
  </div>
</template>
